import React from "react";
import ReactDOM from 'react-dom';

import ProductElement from "./ProductElement/ProductElement";
import ProductItems from "./ProductItems/ProductItems";
import MyOrderIcon from "./ProductItems/MyOrderIcon";
import CartSummary from "./ProductItems/CartSummary";
import DealerElement from "./DealerElement/DealerElement";

export default () => {

    const productElements = document.querySelectorAll('[data-product-block]');
    for (const productElement of productElements) {
        const data = JSON.parse(productElement.getAttribute('data-product-block'));
        ReactDOM.render(<ProductElement settings={data} />, productElement);
    }

    const productList = document.querySelector('[data-product-list]');
    if (productList) {
        ReactDOM.render(<ProductItems
            page={productList.getAttribute('data-page')}
            group={productList.getAttribute('data-group')} />, productList);
    }

    const orderIcon = document.querySelector('[data-cart-icon]');
    if (orderIcon) {
        ReactDOM.render(<MyOrderIcon />, orderIcon);
    }

    const orderSummary = document.querySelector('[data-order-summary]');
    if (orderSummary) {
        ReactDOM.render(<CartSummary />, orderSummary);
    }

    const dealerElements = document.querySelectorAll('[data-dealers]');
    for (const dealerElement of dealerElements){
        ReactDOM.render(<DealerElement />, dealerElement);
    }

}
